export const auth = {
  login: {
    heading: "ログイン",
    emailOrPhoneLabel: "メールアドレスまたは電話番号",
    emailOrPhonePlaceholder: "メールアドレスまたは電話番号（ハイフンなし）",
    passwordLabel: "パスワード",
    passwordToggleAlt: "パスワード表示切替",
    loginButton: "ログイン",
    loggingIn: "ログイン中...",
    loginFailed: "ログインに失敗しました",
    invalidCredentials:
      "電話番号またはメールアドレスまたはパスワードが正しくありません",
    freePointsPromo: "今なら無料ポイントプレゼント！",
    signupFree: "新規登録【無料】",
    forgotPasswordPrefix: "パスワードをお忘れの方は",
    contactPrefix: "お問い合わせの方は",
    here: "こちら",
    validation: {
      emailOrPhoneRequired: "メールアドレスまたは電話番号を入力してください",
      emailOrPhoneInvalid:
        "メールアドレスまたは10-11桁の電話番号（ハイフンなし）を入力してください",
      passwordRequired: "パスワードを入力してください",
    },
  },
  nativeLogin: {
    loggingIn: "ログイン中...",
  },
  forgotPassword: {
    title: "パスワードの再設定",
    description:
      "ご登録のメールアドレスを入力してください。パスワード再設定用のリンクをお送りします。",
    inputLabel: "メールアドレス",
    inputPlaceholder: "メールアドレス",
    submit: "リンクを送信",
    submitting: "送信中...",
    backToLogin: "ログイン画面に戻る",
    expiry: "リンクの有効期限は30分です。",
    success: "パスワード再設定用のメールを送信しました",
    validation: {
      emailRequired: "メールアドレスを入力してください",
      emailInvalid: "正しいメールアドレスを入力してください",
    },
    error: {
      alreadyIssued:
        "すでに再設定用のリンクを送信しています。しばらく経ってからお試しください",
      failedSend: "送信に失敗しました。しばらく経ってからお試しください",
      generic:
        "送信できませんでした。入力内容をご確認のうえ、もう一度お試しください",
    },
  },
  resetPassword: {
    title: "新しいパスワードの設定",
    description: "新しいパスワードを入力してください。",
    emailLabel: "ログイン用メールアドレス",
    emailDescription:
      "変更する場合は新しいメールアドレスを入力してください。次回以降このメールアドレスとパスワードでログインできます。",
    newPasswordLabel: "新しいパスワード",
    confirmPasswordLabel: "新しいパスワード（確認）",
    submit: "パスワードを変更する",
    submitting: "変更中...",
    success: "パスワードを変更しました。新しいパスワードでログインしてください",
    successWithEmail: "メールアドレスとパスワードを変更しました",
    verifying: "リンクを確認しています...",
    invalidLink: {
      title: "リンクが無効です",
      message:
        "有効期限（30分）が切れているか、URLが正しくありません。お手数ですが、もう一度パスワードの再設定をお試しください。",
      retry: "パスワードの再設定をやり直す",
    },
    validation: {
      emailRequired: "メールアドレスを入力してください",
      emailInvalid: "正しいメールアドレスを入力してください",
    },
    error: {
      generic: "パスワードを変更できませんでした。もう一度お試しください",
      emailRegistered:
        "パスワードは変更されました。ただしこのメールアドレスは既に使用されているため、メールアドレスは変更されていません",
      emailFailed:
        "パスワードは変更されました。ただしメールアドレスの変更に失敗しました",
    },
  },
  register: {
    title: "新規登録",
    name: "ニックネーム",
    email: "メールアドレス",
    password: "パスワード",
    passwordConfirm: "パスワード確認",
    age: "年齢",
    region: "地域",
    regionOverseas: "海外",
    submit: "登録",
    cancel: "キャンセル",
    hasAccount: "すでにアカウントをお持ちの方",
    login: "ログイン",
  },
  nativeRegister: {
    landingTitle: "はじめましょう",
    landingDescription:
      "ニックネームと年齢を入力するだけですぐに始められます。",
    landingTaglinePre: "あなたに",
    landingTaglineMid: "ぴったりな",
    landingTaglineHighlight: "出会い",
    landingTaglinePost: "を",
    landingTaglineSub: "今すぐはじめよう",
    badgeAnonymous: "匿名OK",
    badgeNoIdentity: "本人確認なし",
    badgeFree: "無料登録",
    ageRestriction: "18歳未満の方はご利用いただけません",
    nativeTaglinePre: "ステキな",
    nativeTaglineHighlight: "出会い",
    nativeTaglinePost: "を見つけよう",
    nativeSubtitle: "30秒で登録完了",
    onlineCount: (args: { count: string | number }) =>
      `現在 ${args.count} 人がオンライン`,
    quickStart: "30秒ではじめられます",
    nicknameLabel: "ニックネーム",
    nicknamePlaceholder: "ニックネーム",
    ageLabel: "年齢",
    ageSuffix: "歳",
    regionLabel: "地域",
    randomButton: "ランダム",
    termsLink: "利用規約",
    and: "と",
    privacyLink: "プライバシーポリシー",
    agreeCheckbox: "に同意します",
    bonusNow: "今だけ",
    bonusPoints: "250pt",
    bonusTitle: "プレゼント中！",
    bonusDescription: "新規登録するともらえる",
    freeStart: "無料ではじめる",
    start: "新規登録",
    hasAccount: "すでに会員の方はこちら",
    loggingIn: "ログイン中...",
    registering: "登録中...",
    randomNickname: "ランダム生成",
    agreeTerms: "利用規約とプライバシーポリシーに同意します",
    submitting: "登録中...",
    submit: "無料で始める",
    alreadyRegistered: "すでに登録されています。ログイン画面へ移動します。",
    failed: "登録に失敗しました",
  },
  recovery: {
    title: "アカウント復帰",
    message: "退会済みのアカウントです。復帰しますか？",
    confirm: "登録済みのアカウントで再開",
  },
  contact: {
    modalTitle: "サポートへのお問い合わせ",
    modalDescription:
      "ログインに問題がある場合は、サポートチームにメールでお問い合わせください。端末情報が自動で入力されます。",
    emailButton: "メールで問い合わせる",
    // 件名はブランド（applicationId）ごとに切り替える（例: "[Renka] お問い合わせ"）
    mailSubject: (args: { appName: string }) =>
      `[${args.appName}] お問い合わせ`,
    unknown: "不明",
  },
} as const;
